(function () {
    function initialize() {
    const roots = document.querySelectorAll('[data-post-metrics]:not([data-metrics-initialized])');
    if (!roots.length) return;

    roots.forEach(function (root) {
        const postId = root.dataset.postMetrics;
        if (!postId) return;
        root.dataset.metricsInitialized = "true";

        const endpoint = '/api/metrics/posts/' + encodeURIComponent(postId);
        const mode = root.dataset.metricsMode || 'interactive';
        const likeButton = root.querySelector('[data-metric-like]');
        const likeCount = root.querySelector('[data-metric-likes]');
        const viewCount = root.querySelector('[data-metric-views]');
        const heart = root.querySelector('[data-metric-heart]');

        const render = function (metrics) {
            if (likeCount) likeCount.textContent = Number(metrics.likes || 0).toLocaleString('ko-KR');
            if (viewCount) viewCount.textContent = Number(metrics.views || 0).toLocaleString('ko-KR');
            if (heart) heart.textContent = metrics.liked ? '♥' : '♡';
            if (likeButton) {
                likeButton.setAttribute('aria-pressed', metrics.liked ? 'true' : 'false');
                likeButton.classList.toggle('is-liked', Boolean(metrics.liked));
            }
        };

        const request = async function (path, method) {
            const response = await fetch(path, {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' },
                method: method || 'GET',
            });
            if (!response.ok) throw new Error('metrics request failed');
            return response.json();
        };

        const loadMetrics = async function () {
            try {
                render(await request(mode === 'interactive' ? endpoint + '/view' : endpoint, mode === 'interactive' ? 'POST' : 'GET'));
            } catch (error) {
                try {
                    render(await request(endpoint));
                } catch (fallbackError) {
                    // Metrics are an enhancement; keep the article usable when the API is unavailable.
                }
            }
        };

        if (likeButton) {
            likeButton.addEventListener('click', async function () {
                if (likeButton.disabled || likeButton.classList.contains('is-liked')) return;
                likeButton.disabled = true;
                try {
                    render(await request(endpoint + '/like', 'POST'));
                } catch (error) {
                    // Keep the button available for a later retry without showing a blocking message.
                } finally {
                    likeButton.disabled = false;
                }
            });
        }

        loadMetrics();
    });
    }
    initialize();
    const feed = document.querySelector('[data-post-feed]');
    if (feed) new MutationObserver((records) => {
        if (records.some((record) => Array.from(record.addedNodes).some((node) => node.nodeType === 1 && node.matches('.gh-card')))) initialize();
    }).observe(feed, {childList: true});
})();
